import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=ec77369a&scoped=true&"
import script from "./page404.ts?vue&type=script&lang=ts&"
export * from "./page404.ts?vue&type=script&lang=ts&"
import style0 from "./Page404.vue?vue&type=style&index=0&id=ec77369a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec77369a",
  null
  
)

export default component.exports